import { useApplicationLocalStorage } from '../../../../application/application-hook';
import { Dispatch } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button, MultiSelectDropdown, FormsInputDropdown } from '@platform/components';
import { BusinessChallengesEnum, ProjectPublishingStage } from '@platform/client/schemas';
import { ClientCohortSelects } from '../ClientCohortSelects';

export type ProjectSearchFilters = {
  publishingStage: string[] | null;
  assigned: boolean | null;
  corporateClient: string[] | null;
  plannedCohorts: string[] | null;
  businessChallenges: string[] | null;
};

export const ProjectSearchForm = ({
  setFilters,
}: {
  setFilters: Dispatch<React.SetStateAction<ProjectSearchFilters | undefined>>;
}) => {
  const { updateApplicationData, getApplicationData, clearApplicationData } =
    useApplicationLocalStorage<ProjectSearchFilters>('project-search');
  const { setValue, handleSubmit, register, watch, control, reset } = useForm<ProjectSearchFilters>(
    {
      values: { ...getApplicationData() },
    },
  );

  const clearFilters = () => {
    reset({
      publishingStage: null,
      assigned: null,
      corporateClient: null,
      plannedCohorts: null,
      businessChallenges: null,
    });
    clearApplicationData();
    setFilters(undefined);
  };
  const onSubmit: SubmitHandler<ProjectSearchFilters> = (data) => {
    updateApplicationData(data);
    setFilters(data);
  };
  return (
    <div className='min-w-full flex flex-col gap-4 items-center'>
      <h1>Project Search</h1>
      <form className='min-w-full md:min-w-1/2 flex flex-col gap-1'>
        <FormsInputDropdown
          name='assigned'
          control={control}
          type='default'
          label='Assigned'
          items={[
            { text: 'assigned', textValue: 'true' },
            { text: 'unassigned', textValue: 'false' },
          ]}
          placeholder='All'
        />
        <MultiSelectDropdown
          register={() => register('publishingStage')}
          label='Publishing Stage'
          options={Object.values(ProjectPublishingStage).map((stage) => ({
            label: stage,
            value: stage,
          }))}
          onSelectionChange={(items) => setValue('publishingStage', items)}
          selectedItems={watch('publishingStage') || []}
          placeholder='All'
        />
        <MultiSelectDropdown
          register={() => register('businessChallenges')}
          label='Business Challenges'
          options={Object.values(BusinessChallengesEnum).map((challenge) => ({
            label: challenge,
            value: challenge,
          }))}
          onSelectionChange={(items) => setValue('businessChallenges', items)}
          selectedItems={watch('businessChallenges') || []}
          placeholder='All'
        />
        <p className='mt-3'>Planned Cohorts</p>
        <ClientCohortSelects
          watch={watch}
          register={register}
          setValue={setValue}
          clientField='corporateClient'
          cohortField='plannedCohorts'
          cohortLabel='Cohorts'
        />
      </form>
      <div className='flex justify-between gap-8 items-center mx-2'>
        <Button
          size='sm'
          variant='tertiary-danger'
          onClick={() => clearFilters()}
          additionalClassnames='w-fit'
        >
          clear filters
        </Button>
        <Button
          size='sm'
          variant='primary'
          onClick={handleSubmit(onSubmit)}
          additionalClassnames='w-fit'
        >
          Preview list
        </Button>
      </div>
    </div>
  );
};
